import { HTTP_STATUS } from '../response';
import { Error } from '../error';

export interface FacebookLoginToGameResponse {
	status: HTTP_STATUS;
	errors?: Error[];
}

export type FacebookLoginToGameAction = () => Promise<FacebookLoginToGameResponse>;
